import React, { FunctionComponent, ReactNode, useMemo, useState } from 'react'

import { Theme } from '@lyrahealth-inc/shared-app-logic'

import { ForcedThemeContext, ForcedThemeState } from './ForcedThemeContext'

export interface ForcedThemeProviderProps {
  children: ReactNode
}

/**
 * Provider component that enables programmatic theme overrides.
 * This should wrap the ThemeProvider or be placed at the app root level.
 *
 * When forcedTheme is set (via useForcedDarkMode hook), it takes precedence over
 * the user's theme preference. This is used for flows like Triage and Universal Search
 * that require dark mode regardless of user settings.
 */
export const ForcedThemeProvider: FunctionComponent<ForcedThemeProviderProps> = ({ children }) => {
  const [forcedTheme, setForcedTheme] = useState<Theme | null>(null)

  const value = useMemo<ForcedThemeState>(
    () => ({
      forcedTheme,
      setForcedTheme,
    }),
    [forcedTheme],
  )

  return <ForcedThemeContext.Provider value={value}>{children}</ForcedThemeContext.Provider>
}
